import styled from 'styled-components';
import SideBar from './SideBar';
import { colorSchema } from 'utils/style';

export default styled(SideBar)`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  grid-column: 1 / span 3;
  grid-row: 1;
  z-index: 1;
  .side-bar {
    background: ${colorSchema('white')};
    display: flex;
    height: 100%;
    flex-direction: column;
    padding: 2rem;
    width: 100%;

    &__link {
      display: flex;
      width: 100%;
    }

    &__back {
      align-items: center;
      background: none;
      border: 0;
      color: ${colorSchema('primary')};
      cursor: pointer;
      display: flex;
      font-weight: 500;
      outline: none;
      padding: 0;
      margin-bottom: 2rem;

      &:hover {
        text-decoration: underline;
      }

      svg {
        fill: ${colorSchema('primary')};
        margin-right: 0.5rem;
      }
    }
  }
`;
